// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchInvoiceParams = {
    authToken: string,
    bidderId: number,
    catalogId: number,
    deployment: string,
};

const transform = ({ invoice, results }) => {
    const {
        balance_due: balanceDue,
        buyers_premium_total: buyersPremium,
        currency,
        id,
        invoice_total: invoiceTotal,
        is_sent: sent,
        item_total: itemTotal,
        other_charges: otherCharges,
        payments,
        payments_total: paymentsTotal,
        processing_fee,
        sales_tax,
        shipping_charge,
    } = invoice;

    const items = results.map(item => {
        return {
            catalogId: item.catID,
            imageVersion: item.imageVersion,
            itemId: item.lotID,
            salePrice: item.sale_price,
            sellerId: item.houseID,
            sellerName: item.name,
            title: item.title,
        };
    });

    return {
        data: {
            invoice: {
                balanceDue,
                buyersPremium,
                currency: currency.cur_code,
                id,
                invoiceTotal,
                itemTotal,
                otherCharges,
                payments,
                paymentsTotal,
                processingFee: Number(processing_fee),
                salesTax: Number(sales_tax),
                sent: Boolean(sent),
                shipping: Number(shipping_charge),
            },
            items,
        },
        message: id ? 'Successfully retrieved the invoice.' : 'Error getting the invoice',
        success: Boolean(id),
    };
};

export default {
    fetchInvoice: ({ authToken, bidderId, catalogId, deployment }: FetchInvoiceParams) => {
        return new Promise<any>((resolve, reject) => {
            const request = makeGet({
                authToken,
                deployment,
                path: `<MAINHOST-API>api/bidders/${bidderId}/wonitems/catalogs/${catalogId}`,
                queryParams: { client_version: '5.0', page: 1, pagesize: 1250 },
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response, transform }));
        });
    },
};
